import { ApiError } from "@vana/core";

export class ListUsersError extends ApiError {}

export class ListRolesError extends ApiError {}

export class ListZonesError extends ApiError {}

export class CreateUserError extends ApiError {}

export class UpdateUserError extends ApiError {}
